import React from 'react';
import Combination from '../Combination';
import { CombinationListWrapper } from '../styled';
import { Combinations } from '../alertConfig.types';
import useCombinationFilters from '../../hooks/useCombinationFilters';

export default function DimensionWithCombinations({ combinations = [], customCss, level }: Combinations) {
  const { activeCombinations, deletionInProgressCombinations } = useCombinationFilters(combinations);

  return (
    <CombinationListWrapper customCss={customCss}>
      {activeCombinations.map((combinationSet, ind) => (
          <Combination
            key={ind}
            combinationSet={combinationSet}
            level={level}
          />
      ))}
      {deletionInProgressCombinations.map((combinationSet, ind) => (
          <Combination
            key={ind}
            combinationSet={combinationSet}
            level={level}
          />
      ))}
    </CombinationListWrapper>
  );
}
